import { Panel } from 'larasnap';

export default class extends Panel {
    static registerAs = 'UploadManager';

    init() {
        super.init();
    }

    loadComplete(html) {
        super.loadComplete(html);
    }

    onSelectFile(file) {
        this.fileField.setValue(file);
        this.close();
    }

    setFileField(field) {
        this.fileField = field;
    }
}
